export default __webpack_public_path__ + "static/media/avatar_placeholder.157f088b.png";